export default __webpack_public_path__ + "static/media/AC_6.ac208d34.jpg";